import { MinusIcon, PlusIcon } from 'app/common/presentation/icons'

import styles from './NumberSelector.module.scss'

export interface NumberSelectorProps {
  className?: string
  max?: number
  min?: number
  onChange: (value: string) => void
  step?: number
  value: string
}

const NumberSelector = ({
  className,
  max,
  min,
  onChange,
  step = 1,
  value,
}: NumberSelectorProps) => {
  const parsedValue = Number(value)
  const currentValue = Number.isFinite(parsedValue) ? parsedValue : (min ?? 0)

  const update = (offset: number) => {
    const nextValue = currentValue + offset
    const boundedValue = Math.min(max ?? nextValue, Math.max(min ?? nextValue, nextValue))
    onChange(String(boundedValue))
  }

  const decrementDisabled = min !== undefined && currentValue <= min
  const incrementDisabled = max !== undefined && currentValue >= max

  return (
    <div className={`${styles.numberSelector} ${className ?? ''}`}>
      <button
        aria-label="Decrease"
        disabled={decrementDisabled}
        onClick={() => update(-step)}
        type="button"
      >
        <MinusIcon />
      </button>
      <input
        aria-label="Value"
        max={max}
        min={min}
        onChange={(event) => onChange(event.target.value)}
        step={step}
        type="number"
        value={value}
      />
      <button
        aria-label="Increase"
        disabled={incrementDisabled}
        onClick={() => update(step)}
        type="button"
      >
        <PlusIcon />
      </button>
    </div>
  )
}

export default NumberSelector
